document.addEventListener('DOMContentLoaded', function() {
  const imagePopupContainer = document.getElementById('image-popup-container');
  const imagePopupCloseButton = document.getElementById('image-popup-close');

  window.openImagePopup = function() {
    imagePopupContainer.style.display = 'flex';
  };

  function closeImagePopup() {
    imagePopupContainer.style.display = 'none';
  }

  if (imagePopupCloseButton) {
    imagePopupCloseButton.addEventListener('click', closeImagePopup);
  }

  window.addEventListener('click', function(event) {
    if (event.target === imagePopupContainer) {
      closeImagePopup();
    }
  });
        
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeImagePopup();
    }
  });
});